import http from '../utils/http-common'

const getAll = (param) => {
  return http.get('/lengths', { params: param })
}

const LengthClassDataService = {
  getAll,
}
export default LengthClassDataService
